import { useMemo, useState, useCallback, useEffect } from 'react'
import { FirmSectionData } from '../../../dtos/applicationData'
import { useApplication } from '../../../context/application'
import {
  ApplicationBodyContainer, 
  ApplicationBodyContent,
  DefaultTitle, 
  DefaultSubtitle,
} from '../../../components/application/defaultComponents'
import ApplicationPrebuiltFooter from '../../../components/application/PrebuiltBodyFooter'
import MainForm from 'src/components/application/mainPagesComponents/Firm/MainForm'
import { ValidationError } from 'yup'
import { FirmInfoSchema } from 'src/yup/NewAppSchema'

const Main = () => {
  const { application,  } = useApplication()
  
  const [firmData, setFirmData] = useState<FirmSectionData>(
    () => !!application.firmSection && !!application?.firmSection?.firmName ? {...application.firmSection} : {}
  )
  const [validatedFields, setValidatedFields] = useState<string[]>([])
  const applicantPrimaryInfo = application.applicant

  
  
  const validationSchema = useMemo(() => FirmInfoSchema, [])

  const validateSteps = useMemo(() => {
    try {
      validationSchema.validateSync(firmData, { abortEarly: false })
      return {
        step1: true,
        step2: true,
        step3: true,
        step4: true,
        step5: true,
        step6: true,
        step7: true,
        step8: true,
        step9: true,
        step10 : true
      }
    } catch(err) {
      const { errors } = err as ValidationError

      let steps: {[key: string]: boolean} = {}
      
      for (let stepNumber = 1; stepNumber <= 10; stepNumber++) {
        steps[`step${stepNumber}`] = !errors.includes(`step${stepNumber}`)
      }

      return steps
    }
  }, [firmData, validationSchema])

  const updatedApplicationData = () => ({ 
    ...application, 
    currentPage: window.location.pathname,
    firmSection: {
    ...firmData,
    primaryContact: {
      firstName: applicantPrimaryInfo?.firstName,
      lastName: applicantPrimaryInfo?.lastName,
      email: applicantPrimaryInfo?.emailAddress,
      isFirmAdministrator: applicantPrimaryInfo?.isFirmAdministrator
    }
  }})

  const handleValidateForm = useCallback(() => {
    try {
      validationSchema.validateSync(firmData, { abortEarly: false })
      setValidatedFields([])
    } catch(err) {
      const { errors } = err as ValidationError
      const updatedErrorArray = Array.from(new Set(errors))

      if(JSON.stringify(validatedFields) !== JSON.stringify(updatedErrorArray)) {
        setValidatedFields(updatedErrorArray)
        if(updatedErrorArray.length > 0) {
          document.getElementById(updatedErrorArray[0])?.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }, [firmData, validationSchema, validatedFields])

  useEffect(() => {
    if(Object.keys(validatedFields).length > 0) {
      handleValidateForm()
    }
  }, [handleValidateForm, validatedFields])


  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Let’s learn about your firm.</DefaultTitle>
        <DefaultSubtitle>
          Please fill out the information below.
        </DefaultSubtitle>
        <MainForm
          firmData={firmData}
          setFirmData={setFirmData}
          validateSteps={validateSteps}
          validatedFields={validatedFields}
        />
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute="/new"
        isFormValid={Object.keys(validateSteps).every(key => validateSteps[key] === true)}
        nextRoute="/firm/practice"
        updatedApplication={updatedApplicationData()}
        beforeSaveContinueClick={handleValidateForm}
      />
    </ApplicationBodyContainer>
  )
}

export default Main